export function normalizeApiResponseCode(responseCode) {
  const code = String(responseCode ?? '');
  return /^\d{4}$/.test(code) ? code : null;
}

export function getApiResponseCode(error) {
  return normalizeApiResponseCode(
    error?.responseCode ?? error?.response?.data?.responseCode
  );
}

const TRACE_ID_PATTERN = /^[A-Za-z0-9-]{8,64}$/;
const STAGE_PATTERN = /^[A-Z][A-Z0-9_]{2,63}$/;
const REASON_CODE_PATTERN = /^PM_APPROVAL_[A-Z0-9_]{3,64}_FAILED$/;

export function normalizeApprovalDiagnostic(data) {
  if (!data || typeof data !== "object" || Array.isArray(data)) return null;

  const { source, stage, reasonCode, traceId, retryable } = data;
  if (
    source !== "project-management" ||
    !STAGE_PATTERN.test(stage) ||
    !REASON_CODE_PATTERN.test(reasonCode) ||
    !TRACE_ID_PATTERN.test(traceId) ||
    typeof retryable !== "boolean"
  ) {
    return null;
  }

  return Object.freeze({ source, stage, reasonCode, traceId, retryable });
}

export function createApiError(responseCode, responseText, fallbackMessage, data = null) {
  const approvalDiagnostic = normalizeApprovalDiagnostic(data);
  const message = approvalDiagnostic
    ? `프로젝트 승인 처리 중 오류가 발생했습니다. 추적 ID: ${approvalDiagnostic.traceId}를 관리자에게 전달해 주세요.`
    : responseText || fallbackMessage;
  const error = new Error(message);
  error.responseCode = normalizeApiResponseCode(responseCode);
  error.approvalDiagnostic = approvalDiagnostic;
  return error;
}

export function logSafeApiFailure(scope, error, logger = console.error) {
  const responseCode = getApiResponseCode(error);
  const diagnostic = normalizeApprovalDiagnostic(error?.approvalDiagnostic);
  const fields = [
    "event=API_REQUEST_FAILURE",
    `scope=${scope}`,
    `responseCode=${responseCode || "UNKNOWN"}`,
  ];
  if (diagnostic) {
    fields.push(
      `source=${diagnostic.source}`,
      `stage=${diagnostic.stage}`,
      `reasonCode=${diagnostic.reasonCode}`,
      `traceId=${diagnostic.traceId}`,
      `retryable=${diagnostic.retryable}`
    );
  }
  logger(fields.join(" "));
}
